import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors, typography } from '../../../../themes';

export const YearButtonListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  max-width: calc(3 * (5rem + 4px));
`;

export const YearButton = styled.button<{
  isSelected?: boolean;
  isInRange?: boolean;
  isDisabled?: boolean;
  isUnderlined?: boolean;
}>`
  font-family: ${typography.fontFamily};
  font-weight: 400;
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
  width: 5rem;
  height: 2rem;
  line-height: 2rem;
  padding: 0;
  margin: 0 2px;
  border-radius: 4px;
  text-decoration: none;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  transition:
    background-color 0.15s,
    border-color 0.15s,
    color 0.15s;

  ${({ isSelected, isInRange, isDisabled, isUnderlined }) => {
    if (isDisabled) {
      return css`
        background: transparent;
        border: 1px solid transparent;
        color: #b7b7b7;
      `;
    }

    if (isUnderlined && isSelected) {
      return css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${colors.primary.blue};
        border: 1px solid ${colors.primary.blue};
        color: ${colors.base.white};

        &::after {
          content: '';
          position: absolute;
          left: 10px;
          right: 10px;
          bottom: 2px;
          height: 2px;
          border-radius: 999px;
          background: ${colors.base.white};
        }
      `;
    }

    if (isUnderlined) {
      return css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: 1px solid transparent;
        color: ${colors.base.black};

        &::after {
          content: '';
          position: absolute;
          left: 10px;
          right: 10px;
          bottom: 2px;
          height: 2px;
          border-radius: 999px;
          background: ${colors.primary.blue};
        }

        &:hover {
          border: 1px solid ${colors.primary.blue};
        }
      `;
    }

    if (isSelected) {
      return css`
        background-color: ${colors.primary.blue};
        border: 1px solid ${colors.primary.blue};
        color: ${colors.base.white};
      `;
    }

    if (isInRange) {
      return css`
        background-color: #daf1fc;
        border: 1px solid transparent;
        color: ${colors.base.black};
      `;
    }

    return css`
      background: transparent;
      border: 1px solid transparent;
      color: ${colors.base.black};

      &:hover {
        border: 1px solid ${colors.primary.blue};
      }
    `;
  }}
`;
